<template>
  <div v-if="moduleShow" class="CompanyApplicationDetail">
    <div class="company-application a-5-bg">
      <div class="company-application-bar">
        <div class="application-header a-3-bd">
          <div class="application-step b-2-cl">
            <template v-for="(item, inx) in stepProgress">
              <span
                class="step-icon"
                style="color: #edf4f8"
                :class="actived(item.status).stepBg"
                :key="`stepProgress${inx}`"
              >
                {{ inx + 1 }}
                </span>
                <span :key="`stepProgressText${inx}`" :class="actived(item.status).textCl">{{ item.text }}</span>
              <span
                class="setp-line gray-bd"
                :key="`stepProgressLine${inx}`"
                v-if="lineShow(inx, stepProgress.length)"
              ></span>
            </template>
          </div>
          <h1 class="application-title main-cl">
            {{ headerTitle }}
            <span class="gray-cl title-desc" v-if="applyStatus !== 1">{{ headerDesc }}</span>
          </h1>
        </div>
        <div v-if="companyStatus === 2 && (applyRuleStatus === 1 || applyRuleStatus === 3)">
          <template
            v-if="
              applyStatus === 0 ||
              (applyStatus === 3 && applyRuleStatus === 1) ||
              (applyRuleStatus === 1 && applyStatus === 2 && companyStatus === 2)
            "
          >
            <div class="step a-3-bd">
              <h2 class="main-cl step-title">
                {{ $t("application.companySuper.unApply.stepOne.title") }}
              </h2>
              <p class="gray-cl step-desc">
                {{ $t("application.companySuper.unApply.stepOne.desc")[0] }}
                {{ minCompanyMarginNum }}
                {{ marginCoinSymbol }}
                {{ $t("application.companySuper.unApply.stepOne.desc")[1] }}
              </p>
            </div>
            <div class="step a-3-bd">
              <h2 class="main-cl step-title">
                {{ $t("application.companySuper.unApply.stepTwo.title") }}
              </h2>
              <p class="gray-cl step-desc">
                {{ $t("application.companySuper.unApply.stepTwo.desc")[0] }}
              </p>
            </div>
          </template>
          <div class="step a-3-bd" v-if="applyStatus === 1">
            <p class="b-2-cl step-desc sort">
              {{ $t("application.companySuper.applying.desc")[0] }}<br /><br />
              {{ $t("application.companySuper.applying.desc")[1] }} {{ normalCompanyMarginNum }}
              {{ marginCoinSymbol }}{{ $t("application.companySuper.applying.desc")[2]
              }}<br /><br />
              {{ $t("application.companySuper.applying.desc")[3] }}
            </p>
          </div>
          <div
            class="step a-3-bd"
            v-if="
              (applyStatus === 3 && applyRuleStatus === 3) ||
              (applyStatus === 2 && applyRuleStatus === 3)
            "
          >
            <p
              class="b-2-cl step-desc sort"
              v-html="$t('application.companySuper.applied.desc')"
            ></p>
          </div>
        </div>
        <div v-else-if="applyRuleStatus === 0 || companyStatus === 1">
          <template v-if="applyStatus === 0 || (applyRuleStatus === 0 && applyStatus !== 1)">
            <div class="step a-3-bd">
              <h2 class="main-cl step-title">
                {{ $t("application.company.unApply.stepOne.title") }}
              </h2>
              <p class="step-desc">
                <span>{{ $t("application.company.unApply.stepOne.desc")[0] }}</span>
                <a :href="docAddr" target="_blank" class="blue-cl">
                  {{ $t("application.company.unApply.stepOne.desc")[1] }}</a
                >
                <span>{{ $t("application.company.unApply.stepOne.desc")[2] }}</span>
              </p>
              <p
                class="gray-cl step-desc"
                v-html="$t('application.company.unApply.stepOne.desc')[3]"
              ></p>
            </div>
            <div class="step a-3-bd">
              <h2 class="main-cl step-title">
                {{ $t("application.company.unApply.stepTwo.title") }}
              </h2>
              <p class="step-desc">
                <span class="gray-cl">{{ $t("application.company.unApply.stepTwo.desc")[0] }}</span>
                <a href="javascript:;" class="blue-cl" v-on:click="copyMail(otcCompanyApplyEmail)">
                  {{ otcCompanyApplyEmail }}
                </a>
                <span class="gray-cl">{{ $t("application.company.unApply.stepTwo.desc")[1] }}</span>
              </p>
            </div>
            <div class="step a-3-bd">
              <h2 class="main-cl step-title">
                {{ $t("application.company.unApply.stepThree.title") }}
              </h2>
              <p class="gray-cl step-desc">
                {{ $t("application.company.unApply.stepThree.desc")[0] }}
                {{ normalCompanyMarginNum }}
                {{ marginCoinSymbol }}{{ $t("application.company.unApply.stepThree.desc")[1] }}
              </p>
            </div>
            <div class="step a-3-bd">
              <h2 class="main-cl step-title">
                {{ $t("application.company.unApply.stepFour.title") }}
              </h2>
              <p class="gray-cl step-desc">
                {{ $t("application.company.unApply.stepFour.desc")[0] }}
              </p>
            </div>
          </template>
          <div class="step a-3-bd" v-if="applyStatus === 1">
            <p class="gray-cl step-desc sort" v-html="$t('application.company.applying.desc')"></p>
          </div>
          <div
            class="step a-3-bd"
            v-if="
              (applyStatus === 3 && applyRuleStatus !== 0) ||
              (applyRuleStatus === 1 && applyStatus === 2)
            "
          >
            <p class="gray-cl step-desc sort" v-html="$t('application.company.applied.desc')"></p>
          </div>
        </div>
        <div class="application-region">
          <p class="option-region e-2-c b-2-cl" v-if="btnShow">
            <c-checkBox :value="textFlag" @click="checkoutClick" />
            {{ $t("application.applyRegion.options")[0] }}
            <span class="blue-cl">
              {{ normalCompanyMarginNum }}
              {{ marginCoinSymbol }}
            </span>
            {{ $t("application.applyRegion.options")[1] }}
          </p>
          <div class="btn-region blue-cl">
            <c-button
              v-if="btnShow"
              height="40px"
              width="447px"
              :loading="submitLoading"
              :disabled="submitDisabled"
              @click="submit"
              paddingW="0px"
              style="font-size: 16px;"
              >{{ $t("application.applyRegion.applyBtn") }}
            </c-button>
            <c-button v-if="applying" height="40px" width="447px" :disabled="true" paddingW="0px" style="font-size: 16px;"
              >{{ $t("application.applyRegion.applingBtn") }}
            </c-button>
            <c-button v-if="allPass" height="40px" width="447px" @click="back" paddingW="0px" style="font-size: 16px;"
              >{{
                fiatTradeOpen
                  ? $t("assets.b2c.otcShow.goHall")
                  : $t("application.applyRegion.appliedBtn")
              }}
            </c-button>
            <c-button
              v-if="
                (applyStatus === 3 && applyRuleStatus === 1 && companyStatus === 2) ||
                (applyStatus === 2 && applyRuleStatus === 1 && companyStatus === 2) ||
                (applyStatus === 1 && applyRuleStatus === 0) ||
                (applyStatus === 1 && applyRuleStatus === 1)
              "
              @click="back"
              width="447px"
              className="back-btn"
              paddingW="31px"
              height="40px"
              style="font-size: 16px;"
              >{{
                fiatTradeOpen
                  ? $t("assets.b2c.otcShow.goHall")
                  : $t("application.applyRegion.appliedBtn")
              }}
            </c-button>
            <c-button
              v-if="
                applyRuleStatus === 0 &&
                (applyStatus === 2 || applyStatus === 0 || applyStatus === 3)
              "
              @click="relieveClick"
              width="447px"
              type="hollow"
              class="gray-10-bg gray-cl"
              className="back-btn"
              paddingW="31px"
              height="40px"
              style="font-size: 16px;"
              >{{ this.$t("application.applyRegion.cancelBtn") }}
            </c-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { myStorage, logImg, getCoinShowName } from '@/utils';

export default {
  name: 'CompanyApplication',
  data() {
    return {
      textFlag: true,
      copyTime: 0,
      submitLoading: false, // 提交按钮loading
      superCompany: false,
      stepProgress: this.$t('application.stepProgress'),
      moduleShow: false,
    };
  },
  watch: {},
  computed: {
    market() {
      return this.$store.state.baseData.market;
    },
    fiatTradeOpen() {
      const base = this.$store.state.baseData.publicInfo;
      if (base && base.switch && base.switch.fiat_trade_open === '1') {
        return true;
      }
      return false;
    },
    otcCompanyInfo() {
      return this.userInfo.otcCompanyInfo || {};
    },
    userCompanyInfo() {
      return this.userInfo.userCompanyInfo || {};
    },
    headerDesc() {
      const { applyStatus, applyRuleStatus } = this;
      let str = '';
      switch (applyStatus) {
        case 0: {
          str = this.$t('application.company.head.desc');
          break;
        }
        case 3: {
          str = this.$t('application.company.head.descApplied');
          if (applyRuleStatus === 0 || applyRuleStatus === 1) {
            str = this.$t('application.company.head.desc');
          }
          break;
        }
        case 2: {
          if (applyRuleStatus === 1 || applyRuleStatus === 0) {
            str = this.$t('application.company.head.desc');
          }
          break;
        }
        default: {
          str = '';
        }
      }
      return str;
    },
    headerTitle() {
      const { applyStatus, applyRuleStatus, companyStatus } = this;
      let companyTypeS = 1;
      let str = '';
      const applyMap = {
        0: '',
        1: 'Appling',
        3: 'Applied',
      };
      const companyMap = {
        1: '',
        2: 'Super',
      };
      let applyType = applyMap[this.applyStatus];
      if (this.applySuper) {
        applyType = '';
      } else if (applyStatus === 1 && applyRuleStatus === 0) {
        applyType = 'Appling';
      } else if (
        (applyStatus === 2 && applyRuleStatus === 1 && companyStatus === 1)
        || (applyStatus === 2 && applyRuleStatus === 3)
      ) {
        applyType = 'Applied';
      } else if (
        (applyStatus === 2 && (applyRuleStatus === 1 || applyRuleStatus === 0))
        || (applyStatus === 3 && applyRuleStatus === 0)
        || (applyStatus === 3 && applyRuleStatus === 1 && companyStatus === 2)
      ) {
        applyType = '';
      }
      if (
        (applyRuleStatus === 1 && companyStatus === 2)
        || (applyStatus === 3 && applyRuleStatus === 3)
        || (applyStatus === 2 && applyRuleStatus === 3)
        || (applyStatus === 3 && applyRuleStatus === 1 && companyStatus === 2)
      ) {
        companyTypeS = 2;
      }
      const companyTypeDesc = companyMap[companyTypeS];
      str = this.$t(`application.company${companyTypeDesc}.head.title${applyType}`);
      if (str.indexOf('undefined') > -1) {
        str = '';
      }
      return str;
    },
    applySuper() {
      const { applyStatus, applyRuleStatus, companyType } = this;
      return (applyStatus === 3 || applyStatus === 2) && applyRuleStatus === 1 && companyType === 2;
    },
    companyStatus() {
      return Number(this.otcCompanyInfo.status);
    },
    applyStatus() {
      return Number(this.userCompanyInfo.applyStatus);
    },
    marginCoinSymbol() {
      return this.otcCompanyInfo.marginCoinSymbol;
    },
    normalCompanyMarginNum() {
      let no = 0;
      if (this.applyRuleStatus === 0) {
        no = Number(this.otcCompanyInfo.normalCompanyMarginNum);
      } else if (this.applyRuleStatus === 1) {
        no = Number(this.otcCompanyInfo.superCompanyMarginNum);
      }
      return no;
    },
    minCompanyMarginNum() {
      let no = 0;
      if (this.applyRuleStatus === 0) {
        no = Number(this.otcCompanyInfo.normalCompanyMarginNum);
      } else if (this.applyRuleStatus === 1) {
        no = Number(this.otcCompanyInfo.superCompanyMarginNum) - Number(this.otcCompanyInfo.normalCompanyMarginNum);
      }
      return no;
    },
    otcCompanyApplyEmail() {
      return this.otcCompanyInfo.otcCompanyApplyEmail;
    },
    /*
     * applyRuleStatus
     * 0: 未认证
     * 1: 普通商户
     * 2: 普通商户解除
     * 3: 超级商户
     * 4: 超级商户解除
     * */
    applyRuleStatus() {
      return Number(this.userCompanyInfo.status);
    },
    allPass() {
      const { applyStatus, applyRuleStatus, companyStatus } = this;
      return (
        (applyRuleStatus === 3 && (applyStatus === 3 || applyStatus === 2))
        || ((applyStatus === 3 || applyStatus === 2) && applyRuleStatus === 1 && companyStatus === 1)
      );
    },
    applyPass() {
      const { applyStatus, applyRuleStatus } = this;
      return (
        (applyRuleStatus === 3 && applyStatus === 3) || (applyStatus === 3 && applyRuleStatus === 1)
      );
    },
    applying() {
      let bol = false;
      const { applyStatus, applyRuleStatus } = this;
      if (
        applyStatus === 1
        && (applyRuleStatus === 1 || applyRuleStatus === 3 || applyRuleStatus === 0)
      ) {
        bol = true;
      }
      return bol;
    },
    relieving() {
      let bol = false;
      const { applyStatus, applyRuleStatus } = this;
      if (applyStatus === 1 && (applyRuleStatus === 2 || applyRuleStatus === 4)) {
        bol = true;
      }
      return bol;
    },
    docAddr() {
      return this.otcCompanyInfo.docAddr;
    },
    submitDisabled() {
      return !this.textFlag;
    },
    btnShow() {
      const { applyStatus, applyRuleStatus, companyStatus } = this;
      return (
        applyStatus === 0
        || (applyStatus === 3 && applyRuleStatus === 1 && companyStatus === 2)
        || (applyStatus === 2 && applyRuleStatus === 1 && companyStatus === 2)
        || (applyRuleStatus === 0 && applyStatus !== 1)
      );
    },
    userInfo() {
      return this.$store.state.baseData.userInfo || {};
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    getShowCoin(v) {
      let str = v;
      if (this.market && this.market.coinList) {
        str = getCoinShowName(v, this.market.coinList);
      }
      return str;
    },
    init() {
      const { applyRuleStatus, applyStatus } = this;
      if (this.companyStatus === 0) {
        this.$router.push('/');
      } else if ((applyRuleStatus === 2 || applyRuleStatus === 4) && applyStatus === 1) {
        this.$router.push('/companyApplication');
      } else {
        this.moduleShow = true;
      }
    },
    relieveClick() {
      const { history } = window;
      if (!history.state) {
        this.$router.push('/companyApplication');
      } else {
        history.back();
      }
    },
    lineShow(inx, len) {
      return inx + 1 < len;
    },
    copyMail(val) {
      const time = new Date().getTime();
      if (time - this.copyTime > 1000) {
        this.$bus.$emit('tip', { text: '复制成功', type: 'success' });
        const save = function save(e) {
          e.clipboardData.setData('text/plain', val);
          e.preventDefault();
        };
        document.addEventListener('copy', save, false);
        document.execCommand('copy');
        document.removeEventListener('copy', save);
        this.copyTime = time;
      }
    },
    actived(type) {
      const { applyStatus, applyRuleStatus, companyStatus } = this;
      let count = applyStatus;
      if (
        (applyRuleStatus === 1 && applyStatus === 3 && companyStatus === 2)
        || (applyRuleStatus === 0 && applyStatus !== 1)
        || (applyStatus === 2 && applyRuleStatus === 1)
      ) {
        count = 0;
      }
      if (applyStatus === 2 && (applyRuleStatus === 1 || applyRuleStatus === 3)) {
        count = 3;
      }
      return {
        stepBg: count >= type ? 'blue-bg' : 'gray-30-bg ',
        textCl: count >= type ? 'main-cl' : 'gray-cl ',
      };
    },
    checkoutClick(flag) {
      this.textFlag = flag;
    },
    back() {
      this.$router.push('/otc');
    },
    applyCompany() {
      let type = 1;
      if (this.applyRuleStatus === 0) {
        type = 0;
      }
      if (this.applyRuleStatus === 1) {
        type = 1;
      }
      this.axios({
        url: this.$store.state.url.common.company_apply,
        hostType: 'otc',
        method: 'post',
        params: {
          type,
        },
      }).then((data) => {
        if (!Number(data.code)) {
          this.$bus.$emit('tip', { text: data.msg, type: 'success' });
          this.$store.dispatch('getUserInfo');
          myStorage.remove('companyAppling');
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
        this.submitLoading = false;
      });
    },
    submit() {
      this.submitLoading = true;
      this.axios({
        url: this.$store.state.url.common.otc_account_list,
        hostType: 'ex',
        method: 'post',
      }).then((data) => {
        if (!Number(data.code)) {
          const { allCoinMap } = data.data;
          let hasSymbol = false;
          allCoinMap.forEach((item) => {
            if (item.coinSymbol === this.marginCoinSymbol) {
              hasSymbol = true;
              if (Number(item.normal) >= this.minCompanyMarginNum) {
                this.applyCompany();
              } else {
                this.$bus.$emit('tip', {
                  text: this.fiatTradeOpen
                    ? this.$t('assets.b2c.otcShow.unEnough')
                    : this.$t('application.unEnough'),
                  type: 'error',
                });
                this.submitLoading = false;
              }
            }
          });
          if (!hasSymbol) {
            logImg({
              host: window.location.host,
              type: 'marginCoinSymbol',
              path: window.location.href,
              ds: 'marginCoinSymbol error',
              data: {
                marginCoinSymbol: this.marginCoinSymbol,
                allCoinMap: allCoinMap.map(i => i.coinSymbol),
              },
              t: new Date().getTime(),
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';

.CompanyApplicationDetail {
  .company-application {
    width: 100%;
    margin: 0 auto;

    .step-icon {
      width: 28px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      line-height: 28px;
      text-align: center;
      font-size: 14px;
      margin-right: 10px;
    }

    .application-header {
      padding-top: 60px;
      padding-left: 24px;
      padding-bottom: 40px;
      border-bottom-width: 1px;
      border-bottom-style: solid;
    }

    .application-step {
      display: flex;
      align-items: center;
      height: 50px;
      line-height: 50px;
      padding-right: 24px;
    }

    .application-title {
      font-size: 20px;
      margin-top: 40px;

      .title-desc {
        font-size: 14px;
        margin-left: 16px;
      }
    }

    .step {
      padding-left: 24px;
      font-size: 14px;
      border-bottom-width: 1px;
      border-bottom-style: solid;
      padding-top: 42px;
      padding-bottom: 42px;
      padding-right: 60px;

      .step-title {
        margin-bottom: 16px;
        font-size: 18px;
      }
    }

    .setp-line {
      flex: 1;
      display: inline-block;
      border-top-style: dashed;
      border-top-width: 1px;
      vertical-align: middle;
      margin-right: 60px;
      margin-left: 60px;
    }

    .option-region {
      font-size: 14px;
      margin-bottom: 17px;
    }

    .application-region {
      padding: 40px 24px 62px;
    }

    .back-btn {
      margin-left: 27px;
      padding: 10px;
      vertical-align: bottom;
      display: inline-block;
      border: none;
    }

    .btn-region {
      padding-bottom: 30px;
      display: flex;
      justify-content: space-between;
    }

    .application-desc {
      font-size: 12px;
      margin-top: 20px;
    }

    .step-desc {
      font-size: 14px;
      line-height: 26px;
    }

    .sort {
      line-height: 22px;
    }

    .back-btn {
      margin-left: 10px;
    }
  }
}
</style>
